import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Purchase order grid — column definitions.
 * Modeled after BillGrid but adapted for purchase orders.
 */

const currencyFormatter = (params) => {
  if (params.value == null) return '';
  return params.value.toFixed(2);
};

const dateFormatter = (params) => {
  if (!params.value) return '';
  return new Date(params.value).toLocaleDateString();
};

const StatusRenderer = (params) => {
  const { is_sent, is_received } = params.data ?? {};
  let status = 'Draft';
  let colorClass = 'text-blue-500 bg-blue-50';

  if (is_sent) {
    status = 'Sent';
    colorClass = 'text-amber-600 bg-amber-50';
  }
  else if (is_received) {
    status = 'Received';
    colorClass = 'text-emerald-600 bg-emerald-50';
  }

  return (
    <div className="flex items-center h-full">
      <span className={`px-2 py-0.5 rounded-xl text-xs font-semibold flex items-center gap-1 ${colorClass}`}>
        {status}
      </span>
    </div>
  );
};

export default function PurchaseGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'purchase_order_date', headerName: 'Date', maxWidth: 120, valueFormatter: dateFormatter },
      { field: 'purchase_number', headerName: 'PO No.', maxWidth: 120 },
      {
        headerName: 'Supplier',
        maxWidth: 200,
        flex: 2,
        valueGetter: (params) =>
          params.data.supplier?.supplier_name || params.data.supplier_name || 'Unknown',
      },
      { field: 'reference', headerName: 'Reference', maxWidth: 150 },
      { field: 'delivery_date', headerName: 'Delivery Date', maxWidth: 130, valueFormatter: dateFormatter },
      { field: 'total_amount', headerName: 'Amount', valueFormatter: currencyFormatter, maxWidth: 130, type: 'rightAligned' },
      { headerName: 'Status', cellRenderer: StatusRenderer, minWidth: 120 },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="purchase-orders.csv"
      editLabel="View/Edit"
      pagination
      paginationSize={20}
    />
  );
}
